import { render } from "./actuWidget.vue?vue&type=template&id=5fbc5316&scoped=true"
import script from "./actuWidget.vue?vue&type=script&lang=js"
export * from "./actuWidget.vue?vue&type=script&lang=js"

import "./actuWidget.vue?vue&type=style&index=0&id=5fbc5316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbc5316"]])

export default __exports__